import { getClassLevel } from "../shared/getClassLevel";
import { evaluateDivineSmite } from "./divineSmite";
import { evaluateDivineFavor } from "./divineFavor";
import { evaluateRadiantStrikes } from "./radiantStrikes";

// Divine Smite, Searing Smite and Divine Favor are Paladin spells, so the Paladin adapter owns their hit damage, with
// Radiant Strikes (Paladin 11).
const paladinAdapter = Object.freeze({
  id: "paladin",
  getClassLevel: (character) => getClassLevel(character, "paladin"),
  evaluateOnHit: (context, queries) => [evaluateDivineFavor({ context, queries }), evaluateRadiantStrikes({ context }), evaluateDivineSmite({ context, queries })],
});

export default paladinAdapter;
